
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";

const FreehandToFigjam = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/FreehandToFigjam"
        ogImage="/images/freehand2figjam-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FreehandToFigjam:title")}
        subtitle={t("page/FreehandToFigjam:subtitle")}
        magicianLogoFile="freehand"
        showStartsAt={false}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/FreehandToFigjam:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/FreehandToFigjam:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/freehand-to-figjam-example.png",
          alt: "Invision Freehand to Figjam Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/FreehandToFigjam:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/freehand-to-figjam-converted-file-elements.jpg",
          alt: t("page/FreehandToFigjam:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/FreehandToFigjam:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/FreehandToFigjam:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/FreehandToFigjam:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "ARROW-BLACK",
            title: t(
              "page/FreehandToFigjam:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/FreehandToFigjam:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
      />
      <ConversionSection
        title={t("page/FreehandToFigjam:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t(
              "page/FreehandToFigjam:section/conversion.badges.supportsAll",
            ),
          },
          {
            iconType: "NOTES",
            text: t(
              "page/FreehandToFigjam:section/conversion.badges.stickyNotes",
            ),
          },
          {
            iconType: "ARROW-BLACK",
            text: t(
              "page/FreehandToFigjam:section/conversion.badges.connectors",
            ),
          },
        ]}
        elements={{
          from: {
            iconType: "FREEHAND-ICON",
            image: "/images/freehand2figjam-freehand-preview.jpg",
            title: "Invision Freehand Demo Preview",
          },
          to: {
            iconType: "FIGJAM",
            image: "/images/freehand2figjam-figjam-preview.jpg",
            title: "Figjam Import Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.freehandToFigjamPage")}
        href="#upload"
        isBetaFormat
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default FreehandToFigjam;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/freehand-to-figjam',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  